import { debounce } from 'lodash';

import setFiltersURL from 'hb-react/frontoffice/apps/Filters/utils/setFiltersURL';

export const handleSetFiltersURL = debounce(
  (searchParams, currentFilters, defaultFilters, ignoredParamsKeys) =>
    setFiltersURL({
      searchParams,
      values: currentFilters,
      initialValues: defaultFilters,
      ignoredParamsKeys,
    }),
  300,
);
